// settings for header

export const headerSrcoll = () => {
  const headerEl = document.querySelector('.js-header') as HTMLElement;
  const mv = document.querySelector('.top__mv') as HTMLElement;
  const articleHeader = document.querySelector(
    '.article-header'
  ) as HTMLElement;

  if (!headerEl) return;

  if (mv) {
    const mvHeight = mv.offsetHeight;
    if (window.scrollY > mvHeight) {
      headerEl.style.opacity = '1';
    } else {
      headerEl.style.opacity = '0';
    }

    document.addEventListener('scroll', () => {
      if (window.scrollY > mvHeight) {
        headerEl.style.opacity = '1';
      } else {
        headerEl.style.opacity = '0';
      }
    });
  }

  if (articleHeader) {
    const articleHeaderHeight = articleHeader.offsetHeight;
    if (window.scrollY > articleHeaderHeight) {
      headerEl.style.opacity = '1';
    } else {
      headerEl.style.opacity = '0';
    }

    document.addEventListener('scroll', () => {
      if (window.scrollY > articleHeaderHeight) {
        headerEl.style.opacity = '1';
      } else {
        headerEl.style.opacity = '0';
      }
    });
  }
};

export const headerToggle = () => {
  const hamburgerEl = document.querySelector('.js-hamburger') as HTMLElement;
  const headerEl = document.querySelector('.js-header') as HTMLElement;

  if (!hamburgerEl || !headerEl) return;

  hamburgerEl.addEventListener('click', () => {
    if (headerEl.classList.contains('active')) {
      headerEl.classList.remove('active');
      hamburgerEl.classList.remove('active');
    } else {
      headerEl.classList.add('active');
      hamburgerEl.classList.add('active');
    }
  });
};

export const headerSubmenu = () => {
  const submenuTriggerEl = document.querySelectorAll(
    '.js-submenu-trigger'
  ) as NodeListOf<HTMLElement>;
  const submenuEl = document.querySelectorAll(
    '.sub-menu'
  ) as NodeListOf<HTMLElement>;

  if (!submenuTriggerEl || !submenuEl) return;
  submenuTriggerEl.forEach((triggerEl) => {
    triggerEl.addEventListener('click', () => {
      triggerEl.classList.toggle('active');
      triggerEl.nextElementSibling?.classList.toggle('active');
    });
  });
};
